import React, { Component, Fragment, createRef } from "react";
import { connect } from "react-redux";
import { Field } from "react-final-form-html5-validation";
import * as actions from "../../actions";
import SignatureCanvas from "react-signature-canvas";
import DropdownDate from "react-dropdown-date";
import { OnChange } from "react-final-form-listeners";
import { textField, textareaField, stateList } from "../helpers/Form";
import ToggleableConsentGroup from './ToggleableConsentGroup';
import {
    isRequiredText,
    conditionallyRequiredDate,
    isRequiredQuestionSelection,
    conditionallyRequiredSignature,
    conditionallyRequiredSelection,
    conditionallyRequiredTextarea,
    isRequiredPhoneNumber,
    numberValidator,
    validateEmail,
    isRequiredSelectionCheckbox,
    isRequiredSignature,
    isRequiredDate,
    isRequired,
    conditionallyRequiredSignatureDate,
    isRequiredStateSelection,
    isRequiredSelection,
    conditionallyRequiredText,
    validateEmailCG
} from "../helpers/Validation";
import { hipaaTextHeader } from "../terms/hipaa";
import { hipaaTextMore } from "../terms/hipaa";
import { hipaaTextFull } from "../terms/hipaa";
import { signupConsent } from "../terms/hipaa";
import { consentToReceiveTexts } from "../terms/hipaa";
import { signupAuthorization } from "../terms/hipaa";
import arrowUp from "../../assets/images/arrow-up.png";
import arrowDown from "../../assets/images/arrow-down.png";
import SignatureDate from "../hooks/SignatureDate";
import ShortEnrollmentHeader from "./ShortEnrollmentHeader";

class GetStartedForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gender: null,
            preferredContact: null,
            patientSignature: null,
            patientResides: null,
            preferredContactTime: null,
            personalRepresentative: false,
            descriptionOfAuthority: null,
            dob: false,
            patientSignatureDate: false,
            hipaaTextBox: false,
            agreeToReceive: false,
            showAgreeToReceive: false,
            consent: null,
        };
    }

    clearSigCanvas = (refName) => {
        this[refName + "Ref"].clear();
    };

    storeSigData = (refName) => {
        this.setState({
            ...this.state,
            [refName]: this[refName + "Ref"].getTrimmedCanvas().toDataURL(),
        });
        this.props.questionAnswer(refName, this[refName + "Ref"].toDataURL());
    };

    toggleTextBox = (name) => {
        this.setState({
            ...this.state,
            [name]: !this.state[name],
        });
        this.hipaaTextBox.current.scrollIntoView({ behavior: "smooth" });
    };

    handleAgreeToReceiveChange = () => {
        this.setState({ agreeToReceive: !this.state.agreeToReceive });
        sessionStorage.setItem('agreeToReceive', this.state.agreeToReceive ? 0 : 1);
    }

    checkBoxOnChange = (checked) => {
        console.log(checked);
    };

    phoneTwo = createRef();
    phoneThree = createRef();
    cgPhoneTwo = createRef();
    cgPhoneThree = createRef();
    insPhoneTwo = createRef();
    insPhoneThree = createRef();
    doctorPhoneTwo = createRef();
    doctorPhoneThree = createRef();
    facilityPhoneTwo = createRef();
    facilityPhoneThree = createRef();
    hipaaTextBox = createRef();

    render() {
        const { hipaaTextBox } = this.state;
        const {
            preferredContact,
            doctorPhoneOne,
            doctorPhoneTwo,
            doctorPhoneThree,
            phoneOne,
            phoneTwo,
            phoneThree,
            cgPhoneOne,
            cgPhoneTwo,
            cgPhoneThree,
            insPhoneOne,
            insPhoneTwo,
            insPhoneThree,
            hipaa,
            personalRepresentative = false,
            personalRepresentativeCheck = false,
            descriptionOfAuthority,
            patientSignatureDate,
            patientSignature,
            dob,
            diagnosis,
            personalRepActive = "#857C7A",
            consent,

        } = this.props.questionOptions;

        let todaysDate = new Date().toLocaleString("en-US", {
            month: "long",
            day: "numeric",
            year: "numeric",
        });

        return (
            <Fragment>
                <div className="row spacer-medium desktop-sm">&nbsp;</div>
                <div className="row">
                    <div className="col">
                        <h3>complete your enrollment.</h3>
                        <p>
                            You can complete the patient enrollment form using
                            the form fields below (recommended) or{" "}
                            <a
                                href="/nuplazid/pdf/patient-self-enrollment-form.pdf"
                                target="_blank"
                            >
                                download a PDF version
                            </a>{" "}
                            to fill out and email to{" "}
                            <a
                                href="mailto:acadiaconnect@acadia-pharm.com"
                                style={{ textDecoration: "underline" }}
                            >
                                nuplazid@acadiaconnect.com
                            </a>
                            .
                        </p>
                        <p>
                            *&nbsp;
                            <i class="required-field-indication">
                                Indicates required field.
                            </i>
                        </p>
                    </div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>
                {/*
                    <div className="mobile-sm" style={{display: 'none'}}>
                        <div className="row">
                            <div className="col">
                                <img src="/images/reminder-email-placeholder@2x.png" />
                            </div>
                        </div>
                    </div>
                    <div className="row spacer-large mobile-sm" style={{display: 'none'}}>&nbsp;</div>
                    */}

                <div className="row" style={{ display: "none" }}>
                    <div className=" col py-5 px-4 mx-3 blue-bg">
                        <div className="blue-bg">
                            <p className="reminder-copy">
                                Busy? Send yourself a reminder for later.
                            </p>
                            <Field
                                name="reminderEmail"
                                label="Email address*"
                                component={textField}
                                /*validate={isRequiredText}*/
                                customMarginBottom="50px"
                            />
                        </div>
                        <button
                            className="button white reminder-button"
                            type="button"
                            onClick={(e) => { }}
                        >
                            SEND
                        </button>
                    </div>
                </div>

                <div className="row spacer-large mobile-sm">&nbsp;</div>
                <div className="row">
                    <div className="col-2 col-sm-2">
                        <p className="header-number consumer">1</p>
                    </div>
                    <div
                        className="col-sm-10 col-10"
                        style={{ paddingTop: "22px" }}
                    >
                        <h3 className="euclid">PATIENT INFORMATION</h3>
                        <div className="d-sm-inline-block">
                            <i>Tell us about yourself.</i>
                        </div>
                        <br />
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="patientFirstName"
                            label="Patient first name*"
                            component={textField}
                            validate={isRequiredText}
                        />
                    </div>
                    <div className="col-sm">
                        <Field
                            name="patientLastName"
                            label="Patient last name*"
                            component={textField}
                            validate={isRequiredText}
                            customMarginBottom="50px"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <Field
                            name="dob"
                            component="input"
                            defaultValue={dob}
                            validate={isRequiredDate}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <label
                                        className={
                                            meta.error && meta.touched
                                                ? "fancy-label error"
                                                : "fancy-label"
                                        }
                                        htmlFor="dob"
                                    >
                                        Date of birth*
                                    </label>
                                    <DropdownDate
                                        onDateChange={(date) => {
                                            this.props.questionAnswer(
                                                "dob",
                                                `${(date.getMonth()) + 1}/${date.getDate()}/${date.getFullYear()}`
                                            );
                                        }}
                                        order={
                                            ["month", "day", "year"] // Order of the dropdowns
                                        }
                                        defaultValues={{
                                            month: "Month",
                                            day: "Day",
                                            year: "Year",
                                        }}
                                        selectedDate={dob ? dob : ""}
                                        options={{
                                            yearReverse: true,
                                        }}
                                        classes={{
                                            month:
                                                meta.error && meta.touched
                                                    ? "dateDropDownMonthClass error"
                                                    : "dateDropDownMonthClass",
                                            day:
                                                meta.error && meta.touched
                                                    ? "dateDropDownDayClass error"
                                                    : "dateDropDownDayClass",
                                            year:
                                                meta.error && meta.touched
                                                    ? "dateDropDownYearClass error"
                                                    : "dateDropDownYearClass",
                                        }}
                                    />
                                    {meta.error && meta.touched && meta.error}
                                </Fragment>
                            )}
                        </Field>
                    </div>
                    <div className="col-sm pt-5 pt-sm-0">
                        <Field
                            name="patientAddress"
                            label="Address*"
                            component={textField}
                            validate={isRequiredText}
                            customMarginBottom="50px"
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-6">
                        <Field
                            name="patientCity"
                            label="City*"
                            component={textField}
                            validate={isRequiredText}
                            customMarginBottom="50px"
                        />
                    </div>
                    <div className="col-sm-4">
                        <div
                            className="form-group"
                            style={{ paddingBottom: "30px" }}
                        >
                            <Field
                                name="patientState"
                                component="select"
                                validate={isRequiredStateSelection}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "error"
                                                    : "fancy-label"
                                            }
                                            htmlFor="state"
                                            style={{
                                                marginBottom: "0px",
                                                calc: "(100% - 15px)",
                                            }}
                                        >
                                            State*
                                        </label>
                                        <select
                                            {...input}
                                            className={
                                                meta.error && meta.touched
                                                    ? "select-state-css select-css error"
                                                    : "select-state-css select-css"
                                            }
                                            type="select"
                                            style={{
                                                marginTop: "-2px",
                                                width: "97%",
                                                height: "42px",
                                            }}
                                        >
                                            <option name="" value="">
                                                - Select state -
                                            </option>
                                            {Object.entries(stateList).map(
                                                function (state) {
                                                    return (
                                                        <option
                                                            key={state[0]}
                                                            name="state"
                                                            value={state[0]}
                                                        >
                                                            {state[1]}
                                                        </option>
                                                    );
                                                }
                                            )}
                                        </select>
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                        </div>
                    </div>
                    <div className="col col-sm-2">
                        <Field
                            name="patientZip"
                            label="Zip*"
                            component={textField}
                            validate={isRequiredText}
                            customMarginBottom="50px"
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-sm" style={{ paddingTop: "4px" }}>
                        <Field
                            name="patientEmail"
                            label="Email address*"
                            component={textField}
                            validate={isRequiredText}
                            customMarginBottom="50px"
                        />
                    </div>
                    <div className="col-md">
                        <div className="phone-group phone-group-patient-self-enrollment">
                            <Field
                                name="phoneNumber"
                                component="input"
                                defaultValue={String(
                                    phoneOne + phoneTwo + phoneThree
                                )}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "fancy-label error"
                                                    : "fancy-label"
                                            }
                                            htmlFor="dob"
                                        >
                                            Phone number (mobile preferred)*
                                        </label>
                                    </Fragment>
                                )}
                            </Field>
                            <div className="phone-group">
                                <Field
                                    name="phoneOne"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-area-code error"
                                                        : "form-control inline-phone phone-area-code"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="phoneOne">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "phoneOne",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.phoneTwo.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="phoneTwo"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-prefix error"
                                                        : "form-control inline-phone phone-prefix"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.phoneTwo}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="phoneTwo">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "phoneTwo",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.phoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="phoneThree"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-line-number error"
                                                        : "form-control inline-phone phone-line-number"
                                                }
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.phoneThree}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="phoneThree">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "phoneThree",
                                                value
                                            );
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="phoneNumber"
                                    component="input"
                                    defaultValue={String(
                                        phoneOne + phoneTwo + phoneThree
                                    )}
                                    validate={isRequiredPhoneNumber}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control full-width-input hidden-field"
                                                tabIndex="-1"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                            </div>
                            {/*</div>form group*/}
                        </div>
                        {/*form group*/}
                    </div>
                </div>
                {/*row*/}

                {/*
            #####
            #     #
                #
            #####
            #
            #
            #######
            */}
                {/* 2 */}
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row">
                    <div className="col-2 col-sm-2">
                        <p className="header-number consumer">2</p>
                    </div>
                    <div
                        className="col-sm-10 col-10"
                        style={{ paddingTop: "0px" }}
                    >
                        <h3 className="euclid">DIAGNOSIS INFORMATION</h3>
                        <div className="d-sm-inline-block">
                            <i>Why were you prescribed this medication?</i>
                        </div>
                    </div>
                    <div class="row grey-spacer-col-1"></div>
                </div>
                <div className="row spacer-medium">&nbsp;</div>

                <div className="row">
                    <div className="col-sm blue-font-15-euclid">
                        <Field
                            name="diagnosisRadio"
                            component="input"
                            validate={isRequiredQuestionSelection}
                            defaultValue={diagnosis}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <label
                                        className={
                                            meta.error && meta.touched
                                                ? "fancy-label error"
                                                : "fancy-label"
                                        }
                                        style={{ marginBottom: ".5rem" }}
                                    >
                                        Please confirm diagnosis*
                                    </label>
                                </Fragment>
                            )}
                        </Field>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <div className="radio-field">
                            <Field name="diagnosisRadio" type="radio">
                                {({ input, meta }) => {
                                    return (
                                        <Fragment>
                                            <input
                                                id="diagnosis"
                                                name={input.name}
                                                type="radio"
                                                style={{ flexShrink: "0" }}
                                                onClick={(e) =>
                                                    this.props.questionAnswer(
                                                        "diagnosis",
                                                        "Hallucinations and delusions associated with PD psychosis"
                                                    )
                                                }
                                            />
                                            <div
                                                style={{
                                                    display: "inline-grid",
                                                }}
                                            >
                                                <label htmlFor="diagnosis">
                                                    Hallucinations and delusions
                                                    associated with Parkinson’s
                                                    disease psychosis (PDP)
                                                </label>
                                            </div>
                                        </Fragment>
                                    );
                                }}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row pt-2">
                    <div className="col-sm">
                        <div className="radio-field">
                            <Field name="diagnosisRadio" type="radio">
                                {({ input, meta }) => {
                                    return (
                                        <Fragment>
                                            <input
                                                id="other-diagnosis"
                                                name={input.name}
                                                type="radio"
                                                value="Other diagnosis"
                                                style={{ flexShrink: "0" }}
                                                onClick={(e) =>
                                                    this.props.questionAnswer(
                                                        "diagnosis",
                                                        "Other diagnosis"
                                                    )
                                                }
                                            />
                                            <div
                                                style={{
                                                    display: "inline-grid",
                                                }}
                                            >
                                                <label htmlFor="other-diagnosis">
                                                    Other diagnosis
                                                </label>
                                            </div>
                                        </Fragment>
                                    );
                                }}
                            </Field>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md">
                        <Field
                            name="diagnosisRadio"
                            component="input"
                            validate={isRequiredQuestionSelection}
                            defaultValue={diagnosis}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <input
                                        {...input}
                                        type="text"
                                        className="form-control full-width-input hidden-field"
                                        tabindex="-1"
                                    />
                                    {meta.error && meta.touched && meta.error}
                                </Fragment>
                            )}
                        </Field>
                    </div>
                </div>
                <div className="row py-3">
                    <div className="col-sm">
                        {diagnosis ===
                            "Hallucinations and delusions associated with PD psychosis" && (
                                <>
                                    <label className="fancy-label">
                                        Diagnosis:
                                    </label>
                                    <Field
                                        name="diagnosis"
                                        component={textField}
                                        defaultValue={diagnosis}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className="fancy-input form-control full-width-input"
                                                    value="Hallucinations and delusions associated with PD psychosis."
                                                    defaultValue={diagnosis}
                                                    style={{
                                                        marginTop: "0",
                                                        marginBottom: "50px",
                                                    }}
                                                />
                                            </Fragment>
                                        )}
                                    </Field>
                                </>
                            )}
                        {diagnosis !==
                            "Hallucinations and delusions associated with PD psychosis" && (
                                <Field
                                    name="diagnosis"
                                    label="Diagnosis*:"
                                    component={textField}
                                    validate={isRequiredText}
                                    className="fancy-input form-control full-width-input"
                                    value=""
                                    defaultValue={""}
                                />
                            )}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <div className="d-sm-inline-block">
                            <a href="#isi-content">
                                Please see below for NUPLAZID Important Safety
                                Information
                            </a>
                            .
                        </div>
                    </div>
                </div>
                {/*
            #####
            #     #
                #
            #####
                #
            #     #
            #####
            */}
                {/*3*/}
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="row spacer-medium">&nbsp;</div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-2 col-sm-2">
                            <p className="header-number consumer">3</p>
                        </div>
                        <div
                            className="col-sm-10 col-10"
                            style={{ paddingTop: "0px" }}
                        >
                            <h3 className="euclid">CAREGIVER INFORMATION</h3>
                            <div className="d-sm-inline-block">
                                <i>
                                    (if applicable) Who else can speak on your
                                    behalf?
                                </i>
                            </div>
                        </div>
                        <div class="row grey-spacer-col-1"></div>
                    </div>
                    <div className="row spacer-medium">&nbsp;</div>
                    <div className="row">
                        <div className="col-sm">
                            <Field
                                name="cgFirstName"
                                label="First name"
                                component={textField}
                            />
                        </div>
                        <div className="col-sm pr-0">
                            <Field
                                name="cgLastName"
                                label="Last name"
                                component={textField}
                                customMarginBottom="50px"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm" style={{ paddingTop: "4px" }}>
                            {/* MOVE */}
                            <Field
                                name="cgEmail"
                                label="Email address"
                                component={textField}
                                customMarginBottom="50px"
                                validate={conditionallyRequiredTextarea(
                                    this.state.agreeToReceive
                                )}
                                key={this.state.agreeToReceive ? 1 : 0}
                            />
                            <OnChange name="cgEmail">
                                {(value, previous) => {
                                    if (validateEmailCG(value)) {
                                        this.setState({
                                            ...this.state,
                                            showAgreeToReceive: true
                                        });
                                    } else {
                                        this.setState({
                                            ...this.state,
                                            showAgreeToReceive: false
                                        });
                                    }
                                }}
                            </OnChange>
                        </div>
                        <div className="col-md pr-0">
                            <div className="phone-group">
                                <label className="fancy-label">
                                    Phone number (mobile preferred)
                                </label>
                                <div className="phone-group">
                                    <Field name="cgPhoneOne" component="input">
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className={
                                                        meta.error &&
                                                            meta.touched
                                                            ? "form-control inline-phone phone-area-code error"
                                                            : "form-control inline-phone phone-area-code"
                                                    }
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="123"
                                                    inputMode="numeric"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="cgPhoneOne">
                                        {(value, previous) => {
                                            if (numberValidator(value)) {
                                                this.props.questionAnswer(
                                                    "cgPhoneOne",
                                                    value
                                                );
                                                if (value.length === 3) {
                                                    this.cgPhoneTwo.current.focus();
                                                }
                                            }
                                        }}
                                    </OnChange>
                                    <Field name="cgPhoneTwo" component="input">
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className={
                                                        meta.error &&
                                                            meta.touched
                                                            ? "form-control inline-phone phone-prefix error"
                                                            : "form-control inline-phone phone-prefix"
                                                    }
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="456"
                                                    ref={this.cgPhoneTwo}
                                                    inputMode="numeric"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="cgPhoneTwo">
                                        {(value, previous) => {
                                            if (numberValidator(value)) {
                                                this.props.questionAnswer(
                                                    "cgPhoneTwo",
                                                    value
                                                );
                                                if (value.length === 3) {
                                                    this.cgPhoneThree.current.focus();
                                                }
                                            }
                                        }}
                                    </OnChange>
                                    <Field
                                        name="cgPhoneThree"
                                        component="input"
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className={
                                                        meta.error &&
                                                            meta.touched
                                                            ? "form-control inline-phone phone-line-number error"
                                                            : "form-control inline-phone phone-line-number"
                                                    }
                                                    type="text"
                                                    maxLength="4"
                                                    placeholder="7890"
                                                    ref={this.cgPhoneThree}
                                                    inputMode="numeric"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="cgPhoneThree">
                                        {(value, previous) => {
                                            if (numberValidator(value)) {
                                                this.props.questionAnswer(
                                                    "cgPhoneThree",
                                                    value
                                                );
                                            }
                                        }}
                                    </OnChange>
                                </div>

                                <Field
                                    name="cgPhoneNumber"
                                    component="input"
                                    defaultValue={String(
                                        cgPhoneOne + cgPhoneTwo + cgPhoneThree
                                    )}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control full-width-input hidden-field"
                                                tabIndex="-1"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                {/*</div>form group*/}
                            </div>
                            {/*form group*/}
                        </div>
                    </div>
                    {/*row*/}
                </div>
                {/*
            #
            #    #
            #    #
            #######
                #
                #
                #
            */}
                {/*4*/}
                <div className="row spacer-medium">&nbsp;</div>
                <div className="form-group form-group-step-4">
                    <div className="row">
                        <div className="col-2 col-sm-2">
                            <p className="header-number consumer">4</p>
                        </div>
                        <div
                            className="col-sm-10 col-10"
                            style={{ paddingTop: "0px" }}
                        >
                            <h3 className="euclid">INSURANCE INFORMATION</h3>
                            <div className="d-sm-inline-block">
                                <i>Tell us about your provider.</i>
                            </div>
                        </div>
                        <div class="row grey-spacer-col-1"></div>
                    </div>
                    <div className="row spacer-medium">&nbsp;</div>
                    <div className="row">
                        <div className="col-sm" style={{ paddingTop: "4px" }}>
                            <Field
                                name="insDrugPan"
                                label="Prescription drug plan*"
                                component={textField}
                                validate={isRequiredText}
                            />
                        </div>
                        <div className="col-sm">
                            <div className="form-group">
                                <Field
                                    name="insPhoneNumber"
                                    component="input"
                                    defaultValue={String(
                                        insPhoneOne +
                                        insPhoneTwo +
                                        insPhoneThree
                                    )}
                                    validate={isRequiredPhoneNumber}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control full-width-input hidden-field"
                                                tabIndex="-1"
                                            />
                                            <label
                                                className={
                                                    meta.error && meta.touched
                                                        ? "fancy-label error"
                                                        : "fancy-label"
                                                }
                                                htmlFor="dob"
                                            >
                                                Payer phone number*
                                            </label>
                                        </Fragment>
                                    )}
                                </Field>
                                <div className="phone-group">
                                    <Field
                                        name="insPhoneOne"
                                        component="input"
                                        validate={isRequired}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className={
                                                        meta.error &&
                                                            meta.touched
                                                            ? "form-control inline-phone phone-area-code error"
                                                            : "form-control inline-phone phone-area-code"
                                                    }
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="123"
                                                    inputMode="numeric"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="insPhoneOne">
                                        {(value, previous) => {
                                            if (numberValidator(value)) {
                                                this.props.questionAnswer(
                                                    "insPhoneOne",
                                                    value
                                                );
                                                if (value.length === 3) {
                                                    this.insPhoneTwo.current.focus();
                                                }
                                            }
                                        }}
                                    </OnChange>
                                    <Field
                                        name="insPhoneTwo"
                                        component="input"
                                        validate={isRequired}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className={
                                                        meta.error &&
                                                            meta.touched
                                                            ? "form-control inline-phone phone-prefix error"
                                                            : "form-control inline-phone phone-prefix"
                                                    }
                                                    type="text"
                                                    maxLength="3"
                                                    placeholder="456"
                                                    ref={this.insPhoneTwo}
                                                    inputMode="numeric"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="insPhoneTwo">
                                        {(value, previous) => {
                                            if (numberValidator(value)) {
                                                this.props.questionAnswer(
                                                    "insPhoneTwo",
                                                    value
                                                );
                                                if (value.length === 3) {
                                                    this.insPhoneThree.current.focus();
                                                }
                                            }
                                        }}
                                    </OnChange>
                                    <Field
                                        name="insPhoneThree"
                                        component="input"
                                        validate={isRequired}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    className={
                                                        meta.error &&
                                                            meta.touched
                                                            ? "form-control inline-phone phone-line-number error"
                                                            : "form-control inline-phone phone-line-number"
                                                    }
                                                    type="text"
                                                    maxLength="4"
                                                    placeholder="7890"
                                                    ref={this.insPhoneThree}
                                                    inputMode="numeric"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                    <OnChange name="insPhoneThree">
                                        {(value, previous) => {
                                            if (numberValidator(value)) {
                                                this.props.questionAnswer(
                                                    "insPhoneThree",
                                                    value
                                                );
                                            }
                                        }}
                                    </OnChange>
                                    <Field
                                        name="insPhoneNumber"
                                        component="input"
                                        defaultValue={String(
                                            insPhoneOne +
                                            insPhoneTwo +
                                            insPhoneThree
                                        )}
                                        validate={isRequiredPhoneNumber}
                                    >
                                        {({ input, meta }) => (
                                            <Fragment>
                                                <input
                                                    {...input}
                                                    type="text"
                                                    className="form-control full-width-input hidden-field"
                                                    tabIndex="-1"
                                                />
                                                {meta.error &&
                                                    meta.touched &&
                                                    meta.error}
                                            </Fragment>
                                        )}
                                    </Field>
                                </div>
                                {/*</div>form group*/}
                            </div>
                            {/*form group*/}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-sm-6">
                            <Field
                                name="cardHolderName"
                                label="Cardholder name*"
                                component={textField}
                                validate={isRequiredText}
                                customMarginBottom="50px"
                            />
                        </div>
                        <div className="col-6 col-sm-3">
                            <Field
                                name="insIdNumber"
                                label="Plan ID number*"
                                component={textField}
                                validate={isRequiredText}
                                customInputClass={{ width: "100%" }}
                            />
                        </div>
                        {/*TODO: Have to send custom css to 'textField' component for certain cases - this width should be 100%*/}
                        <div className="col-6 col-sm-3 pl-0">
                            <Field
                                name="insMedIdNumber"
                                label="Medicare ID number*"
                                component={textField}
                                validate={isRequiredText}
                            />
                        </div>
                    </div>
                    {/*row*/}
                </div>
                {/*
            #######
            #
            #
            #####
                #
            #     #
            #####
            */}
                {/*5*/}
                <div className="row spacer-medium">&nbsp;</div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-2 col-sm-2">
                            <p className="header-number consumer">5</p>
                        </div>
                        <div
                            className="col-sm-10 col-10"
                            style={{ paddingTop: "0px" }}
                        >
                            <h3 className="euclid">PRESCRIBER INFORMATION</h3>
                            <div className="d-sm-inline-block">
                                <i>What doctor prescribed this medication?</i>
                            </div>
                        </div>
                        <div class="row grey-spacer-col-1"></div>
                    </div>

                    <div className="row spacer-medium">&nbsp;</div>
                    <div className="row">
                        <div className="col-sm" style={{ paddingTop: "4px" }}>
                            <Field
                                name="doctorName"
                                label="Name*"
                                component={textField}
                                validate={isRequiredText}
                            />
                        </div>
                        <div className="col-sm">
                            <Field
                                name="doctorPhoneNumber"
                                component="input"
                                defaultValue={String(
                                    doctorPhoneOne +
                                    doctorPhoneTwo +
                                    doctorPhoneThree
                                )}
                                validate={isRequiredPhoneNumber}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        <label
                                            className={
                                                meta.error && meta.touched
                                                    ? "fancy-label error"
                                                    : "fancy-label"
                                            }
                                        >
                                            Phone number*
                                        </label>
                                    </Fragment>
                                )}
                            </Field>
                            <div className="phone-group">
                                <Field
                                    name="doctorPhoneOne"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-area-code error"
                                                        : "form-control inline-phone phone-area-code"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="123"
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="doctorPhoneOne">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "doctorPhoneOne",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.doctorPhoneTwo.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="doctorPhoneTwo"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-prefix error"
                                                        : "form-control inline-phone phone-prefix"
                                                }
                                                type="text"
                                                maxLength="3"
                                                placeholder="456"
                                                ref={this.doctorPhoneTwo}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="doctorPhoneTwo">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "doctorPhoneTwo",
                                                value
                                            );
                                            if (value.length === 3) {
                                                this.doctorPhoneThree.current.focus();
                                            }
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="doctorPhoneThree"
                                    component="input"
                                    validate={isRequired}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                className={
                                                    meta.error && meta.touched
                                                        ? "form-control inline-phone phone-line-number error"
                                                        : "form-control inline-phone phone-line-number"
                                                }
                                                type="text"
                                                maxLength="4"
                                                placeholder="7890"
                                                ref={this.doctorPhoneThree}
                                                inputMode="numeric"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                                <OnChange name="doctorPhoneThree">
                                    {(value, previous) => {
                                        if (numberValidator(value)) {
                                            this.props.questionAnswer(
                                                "doctorPhoneThree",
                                                value
                                            );
                                        }
                                    }}
                                </OnChange>
                                <Field
                                    name="doctorPhoneNumber"
                                    component="input"
                                    defaultValue={String(
                                        doctorPhoneOne +
                                        doctorPhoneTwo +
                                        doctorPhoneThree
                                    )}
                                    validate={isRequiredPhoneNumber}
                                >
                                    {({ input, meta }) => (
                                        <Fragment>
                                            <input
                                                {...input}
                                                type="text"
                                                className="form-control full-width-input hidden-field"
                                                tabIndex="-1"
                                            />
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </Fragment>
                                    )}
                                </Field>
                            </div>
                        </div>
                    </div>
                </div>
                {/*                    
                    █▀▀ █░█ █▀▀ █▀▀ █▄▀ █▄▄ █▀█ ▀▄▀
                    █▄▄ █▀█ ██▄ █▄▄ █░█ █▄█ █▄█ █░█
                */}
                {/* <div className="row spacer-small">&nbsp;</div>
                <div className="row consumer-signature">
                    <Field
                        className="form-control full-width-input"
                        type="checkbox"
                        name="agreeToSignUp"
                        component="input"
                    >
                        {({ input, meta }) => (
                            <Fragment>
                                <label className="acadia-checkbox">
                                    <input
                                        {...input}
                                        type="checkbox"
                                        className="consumer-form-checkbox"
                                    />
                                    <span class="checkmark"></span>
                                    <span
                                        className="short-enrollment-checkbox-label"
                                        style={{
                                            color: "var(--darker-grey)",
                                        }}
                                    >
                                        Sign up to receive additional
                                        information to help you or the person
                                        you care for stay informed. Our emails
                                        cover a variety of topics, including
                                        discussing symptoms with your healthcare
                                        provider, starting NUPLAZID, financial
                                        support, and more.
                                    </span>
                                    {meta.error && meta.touched && meta.error}
                                </label>
                            </Fragment>
                        )}
                    </Field>
                    {this.state.showAgreeToReceive ? <Field
                        className="form-control full-width-input"
                        type="checkbox"
                        name="agreeToReceive"
                        component="input"

                    >
                        {({ input, meta }) => (
                            <Fragment>
                                <label className="acadia-checkbox">
                                    <input
                                        {...input}
                                        type="checkbox"
                                        checked={this.state.agreeToReceive}
                                        onChange={
                                            this.handleAgreeToReceiveChange
                                        }
                                        className="consumer-form-checkbox"
                                    />
                                    <span class="checkmark"></span>
                                    <span
                                        className="short-enrollment-checkbox-label"
                                        style={{
                                            color: "var(--darker-grey)",
                                        }}
                                    >
                                        I am the caregiver, and I would like to
                                        receive this information for my loved
                                        one.
                                    </span>
                                    {meta.error && meta.touched && meta.error}
                                </label>
                            </Fragment>
                        )}
                    </Field> : null}

                    <p>
                        By checking the "Sign up" box above, I understand and
                        agree to the{" "}
                        <a target="_blank" href="https://acadia.com/privacy/">
                            Privacy&nbsp;Policy
                        </a>{" "}
                        and{" "}
                        <a target="_blank" href="https://acadia.com/terms/">
                            Terms&nbsp;of&nbsp;Use
                        </a>
                        . I agree to receive communications from Acadia
                        Pharmaceuticals Inc.
                    </p>
                </div> */}
                {/*
            #     #   ###   ######     #       #
            #     #    #    #     #   # #     # #
            #     #    #    #     #  #   #   #   #
            #######    #    ######  #     # #     #
            #     #    #    #       ####### #######
            #     #    #    #       #     # #     #
            #     #   ###   #       #     # #     #
            */}
                {/* <div className="row spacer-medium">&nbsp;</div> */}
                <div className="row consumer-signature">
                    <div className="hipaa">
                        <h3 ref={this.hipaaTextBox}>PATIENT/PARENT/<br className="mobile-sm"/>LEGAL GUARDIAN AUTHORIZATION FOR DISCLOSURE
                            OF HEALTH INFORMATION</h3>
                        <p>
                            <i>Please read before signing</i>
                        </p>
                        <div className="row spacer-small" />
                        <div
                            className={
                                "scroll-terms " +
                                (hipaaTextBox ? "expanded" : "condensed")
                            }
                        >
                            {hipaaTextFull}
                        </div>
                        <button
                            className="btn no-outline"
                            onClick={() => this.toggleTextBox("hipaaTextBox")}
                            type="button"
                        >
                            SEE{" "}
                            {hipaaTextBox ? (
                                <Fragment>
                                    LESS
                                    <img
                                        className="arrow"
                                        src={arrowUp}
                                        alt="arrrow"
                                    />
                                </Fragment>
                            ) : (
                                <Fragment>
                                    MORE
                                    <img
                                        className="arrow"
                                        src={arrowDown}
                                        alt="arrrow"
                                    />
                                </Fragment>
                            )}
                        </button>
                        <br />
                        <div className="d-sm-inline-block">
                            *
                            <i class="required-field-indication">
                                &nbsp;Indicates required field.
                            </i>
                        </div>
                        <div className="row spacer-small" />
                        <div
                            className="relative form-group mt-20px-mobile mb-0px-mobile"
                            style={{ marginTop: "0px" }}
                        >
                            <Field
                                className="form-control full-width-input"
                                type="checkbox"
                                name="agreeToHipaaAuth"
                                component="input"
                                validate={isRequiredSelectionCheckbox}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className="acadia-checkbox">
                                            <input
                                                {...input}
                                                type="checkbox"
                                                className="consumer-form-checkbox"
                                            />
                                            <span class="checkmark"></span>
                                            <span
                                                className="short-enrollment-checkbox-label"
                                                style={{
                                                    color: "var(--darker-grey)",
                                                }}
                                            >
                                                I have read and agree to disclosure authorization.*
                                            </span>
                                            <br/><br/>
                                            {meta.error &&
                                                meta.touched &&
                                                meta.error}
                                        </label>
                                    </Fragment>
                                )}
                            </Field>
                            {/* NEW INPUTS ------------------------------------------ UNO */}
                            <Fragment>
                                <div>
                                    <div className="col-sm">
                                        <Field
                                            name="legalGuardianFirstName"
                                            label="Name*"
                                            component={textField}
                                            validate={isRequiredText}
                                        />
                                    </div>
                                    <div className="col-sm">
                                        <Field
                                            name="legalGuardianRelationshipPatient"
                                            label="Relationship to Patient*"
                                            component={textField}
                                            validate={isRequiredText}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                            <OnChange name="agreeToHipaaAuth">
                                {(value, previous) => {
                                    this.props.questionAnswer("hipaa", value);
                                }}
                            </OnChange>
                        </div>
                        <div className="row spacer-medium mobile">&nbsp;</div>
                        <div className="relative form-group bt-neg-10px-mobile">
                            <Field
                                name="patientSignature"
                                defaultValue={patientSignature}
                                validate={isRequiredSignature}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label
                                            htmlFor="patientSignature"
                                            className={
                                                meta.error && meta.touched
                                                    ? "error"
                                                    : ""
                                            }
                                            style={{ marginTop: "20px" }}
                                        >
                                            <i>Sign Here</i> Patient/Parent/Legal Guardian*:
                                        </label>
                                    </Fragment>
                                )}
                            </Field>

                            <SignatureCanvas
                                penColor="black"
                                canvasProps={{
                                    height: 200,
                                    className: "sig-canvas",
                                }}
                                onEnd={() =>
                                    this.storeSigData("patientSignature")
                                }
                                ref={(ref) => {
                                    this.patientSignatureRef = ref;
                                }}
                                clearOnResize={false}
                            />
                            <button
                                type="button"
                                className="canvas-clear patient-signature-clear"
                                onClick={() =>
                                    this.clearSigCanvas("patientSignature")
                                }
                            >
                                CLEAR
                            </button>
                            <Field
                                name="patientSignature"
                                defaultValue={patientSignature}
                                component="input"
                                validate={isRequiredSignature}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                            <SignatureDate dateFor="patientSignature" />
                        </div>

                        {/* I CONSENT ------------------------------------------ DOS */}
                        <div className="">{signupConsent}</div>
                        <Field
                            className="form-control full-width-input"
                            type="checkbox"
                            name="consentCheck"
                            component="input"
                            validate={isRequiredSelectionCheckbox}
                        >
                            {({ input, meta }) => (
                                <Fragment>
                                    <label className="acadia-checkbox" style={{ marginBottom: "100px" }}>
                                        <input
                                            {...input}
                                            type="checkbox"
                                            className="consumer-form-checkbox"
                                        />
                                        <span class="checkmark"></span>
                                        <span
                                            className="short-enrollment-checkbox-label"
                                            style={{
                                                color: "var(--darker-grey)",
                                            }}
                                        >
                                            I consent*
                                        </span>
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </label>
                                </Fragment>
                            )}
                        </Field>
                        {/* I CONSENT / DO NOT CONSENT ------------------------------------------ TRES */}
                        <div className="row spacer-medium mobile">&nbsp;</div>
                        <div className="relative form-group bt-neg-10px-mobile">
                            {consentToReceiveTexts}
                        </div>

                        <div className="col-sm" style={{ padding: 0 }}>
                            <div className="form-group">
                                <ToggleableConsentGroup
                                    selectedValue={this.state.consent}
                                    onChange={(newValue) => this.setState({ consent: newValue })}
                                    questionAnswer={this.props.questionAnswer}
                                />
                            </div>
                        </div>

                        <div
                            className="relative form-group mt-20px-mobile mb-0px-mobile"
                            style={{ marginTop: "40px" }}
                        >
                        <Fragment>
                            <strong>AUTHORIZATION TO DISCLOSE INFORMATION TO INDIVIDUALS INVOLVED IN MY CARE (Optional)</strong>
                            <br/><br/>
                        </Fragment>
                            <Field
                                className="form-control full-width-input"
                                type="checkbox"
                                name="personalRepresentativeCheck"
                                component="input"
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <label className="acadia-checkbox">
                                            <input
                                                {...input}
                                                type="checkbox"
                                                className="consumer-form-checkbox"
                                            />
                                            <span class="checkmark"></span>
                                            <span
                                              className="short-enrollment-checkbox-label"
                                              style={{ color: personalRepActive, whiteSpace: 'normal' }}
                                            >
                                              { personalRepresentativeCheck === false ? (
                                                <>
                                                  I would like to authorize a personal representative
                                                </>
                                              ) : (
                                                <>
                                                  I would like to authorize a personal representative*
                                                </>
                                              ) }
                                            </span>
                                        </label>
                                    </Fragment>
                                )}
                            </Field>
                            {/* NAME LEGAL GUARDIAN OPTIONAL ------------------------------------------ CUATRO */}
                            <Fragment>
                                I further authorize Acadia to discuss the coordination of my care with the family member(s) and/or caregiver(s) I list below. These individual(s) have my full permission to obtain and disclose personal and medical information about me from Acadia.
                                <br/><br/>
                                Authorized Representative(s):
                                <br/><br/>
                            </Fragment>
                            <Fragment>
                                <div className="">
                                    <div className="col-sm">
                                        <Field
                                            name="legalGuardianFirstNameOptional"
                                            label="Name:"
                                            component={textField}
                                        />
                                    </div>
                                    <div className="col-sm">
                                        <Field
                                            name="legalGuardianRelationshipPatientOptional"
                                            label="Relationship to Patient:"
                                            component={textField}
                                        />
                                    </div>
                                </div>
                            </Fragment>
                            <OnChange name="personalRepresentativeCheck">
                                {(value, previous) => {
                                    this.props.questionAnswer(
                                        "personalRepActive",
                                        value === true ? "#3286A0" : "#857C7A"
                                    );
                                    this.props.questionAnswer(
                                        "personalRepresentativeCheck",
                                        value
                                    );
                                    this.setState({
                                        ...this.state,
                                        personalRepresentative:
                                            value == true ? false : true,
                                    });
                                }}
                            </OnChange>
                        </div>
                        <div className="row spacer-medium mobile">&nbsp;</div>
                        <div className="relative form-group bt-neg-10px-mobile">
                            <label htmlFor="personalRepresentative" style={{ color: personalRepActive }}>
                              { personalRepresentativeCheck
                                ? (
                                  <>
                                    <i>Sign Here</i>{" "}
                                    Patient/Parent/Legal Guardian
                                  </>
                                )
                                : (
                                  <>
                                    <i>Sign Here</i>{" "}
                                    Patient/Parent/Legal Guardian (optional)
                                  </>
                                )
                              }
                            </label>
                            <SignatureCanvas
                                penColor="black"
                                canvasProps={{
                                    height: 200,
                                    className: "sig-canvas",
                                }}
                                onEnd={() =>
                                    this.storeSigData("personalRepresentative")
                                }
                                ref={(ref) => {
                                    this.personalRepresentativeRef = ref;
                                }}
                                clearOnResize={false}
                            />
                            <button
                                type="button"
                                className="canvas-clear"
                                onClick={() =>
                                    this.clearSigCanvas(
                                        "personalRepresentative"
                                    )
                                }
                            >
                                CLEAR
                            </button>
                            <Field
                                name="personalRepresentative"
                                defaultValue={personalRepresentative}
                                component="input"
                                validate={conditionallyRequiredSignature(
                                    personalRepresentativeCheck
                                )}
                                key={personalRepresentativeCheck ? 1 : 0}
                            >
                                {({ input, meta }) => (
                                    <Fragment>
                                        <input
                                            {...input}
                                            type="text"
                                            className="form-control full-width-input hidden-field"
                                            tabIndex="-1"
                                        />
                                        {meta.error &&
                                            meta.touched &&
                                            meta.error}
                                    </Fragment>
                                )}
                            </Field>
                            <SignatureDate dateFor="personalRepresentative" />
                        </div>
                        {/*}
                        <label
                            className="fancy-label"
                            htmlFor="descriptionOfAuthority"
                            style={{ color: "var(--dark-grey)" }}
                        >
                            Description of authority*
                        </label>
                        <Field
                            name="descriptionOfAuthority"
                            component={textareaField}
                            validate={conditionallyRequiredTextarea(
                                personalRepresentative || descriptionOfAuthority
                                    ? 1
                                    : 0
                            )}
                            key={
                                personalRepresentative || descriptionOfAuthority
                                    ? 1
                                    : 0
                            }
                        />
                        */}
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    const { currentStep, questionOptions } = state;
    return { currentStep: currentStep, questionOptions: questionOptions };
};

export default connect(mapStateToProps, actions)(GetStartedForm);
